const sriLankaConfig = {
  production_migration: {
    hostname: 'https://lka-mum-api.dominosindia.in',
    GOOGLE_CLIENT_ID: '757462283726-6f8vfs8fth5nnhigdf9eq5dflgrc0i1e.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '2865961683492122', //'270319194010335', //'246788839330520 for desktop', //238077480767779
    API_KEY: 'WKCR99NBD6', // From India
    DESKTOP_API_KEY: 'WKCR99NBD6',
    GTM_TAG: 'GTM-5ZDCKWX', //GTM-5ZDCKWX //GTM-KP5BZ6X
    domain: 'https://m.dominoslk.com', //'http://lkadev-pwa.dominosindia.in' //'http://m.dominoslk.com'
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_API_KEY_PWA: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-SL-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
    },
  production: {
    hostname: 'https://apis.dominoslk.com',
    GOOGLE_CLIENT_ID: '757462283726-6f8vfs8fth5nnhigdf9eq5dflgrc0i1e.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '2865961683492122', //'270319194010335', //'246788839330520 for desktop', //238077480767779
    API_KEY: 'WKCR99NBD6', // From India
    DESKTOP_API_KEY: 'WKCR99NBD6',
    GTM_TAG: 'GTM-5ZDCKWX', //GTM-5ZDCKWX //GTM-KP5BZ6X
    domain: 'https://m.dominoslk.com', //'http://lkadev-pwa.dominosindia.in' //'http://m.dominoslk.com'
    // CLEVERTAP_ID: 'TEST-RKR-K89-785Z',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_API_KEY_PWA: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-SL-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  uat: {
    hostname: 'https://apis-uat.dominoslk.com',
    GOOGLE_CLIENT_ID: '757462283726-6f8vfs8fth5nnhigdf9eq5dflgrc0i1e.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '246788839330520',
    API_KEY: 'WKCR99NBD6',
    DESKTOP_API_KEY: 'WKCR99NBD6',
    GTM_TAG: 'UA-45014247-30',
    domain: 'https://uat-pwa-csr.dominoslk.com',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_API_KEY_PWA: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-SL-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  beta: {
    hostname: 'https://lka-prod-api.dominosindia.in',
    GOOGLE_CLIENT_ID: '757462283726-6f8vfs8fth5nnhigdf9eq5dflgrc0i1e.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '246788839330520',
    API_KEY: 'WKCR99NBD6', // From India
    DESKTOP_API_KEY: 'WKCR99NBD6',
    GTM_TAG: 'GTM-5ZDCKWX',
    domain: 'https://lka-prod-pwa.dominosindia.in',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_API_KEY_PWA: 'f62d387e107a53d0499acbcc048f8f33',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-SL-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  qa: {
    hostname: 'https://lka-mum-s1.dominosindia.in', //'https://lka-s1.dominosindia.in',
    GOOGLE_CLIENT_ID: '757462283726-6f8vfs8fth5nnhigdf9eq5dflgrc0i1e.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '246788839330520',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY: '1be746dc5827cf05',
    GTM_TAG: 'GTM-5ZDCKWX',
    domain: 'https://s1-lkacsr-pwa.dominosindia.in', //'https://lka-s1-pwa.dominosindia.in',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  'lka-d1': {
    hostname: 'https://apis-dev1.dominoslk.com',
    GOOGLE_CLIENT_ID: '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '259853874853122',
    API_KEY: 'd2aeb489bb8df385',
    DESKTOP_API_KEY: 'd2aeb489bb8df385',
    GTM_TAG: 'UA-45014247-30',
    domain: 'https://lka-d1-csr-pwa.dominoslk.com/',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  development1: {
    hostname: 'https://apis-dev1.dominoslk.com',
    GOOGLE_CLIENT_ID: '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '259853874853122',
    API_KEY: 'd2aeb489bb8df385',
    DESKTOP_API_KEY: 'd2aeb489bb8df385',
    GTM_TAG: 'UA-45014247-30',
    domain: 'https://lka-d1-csr-pwa.dominoslk.com/',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  development2: {
    hostname: 'https://api-lka-dev-2.dominosindia.in',
    GOOGLE_CLIENT_ID: '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '259853874853122',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'UA-45014247-30',
    domain: 'https://lkadev2-pizzaonline.dominosindia.in',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  development3: {
    hostname: 'https://api-lka-dev-2.dominosindia.in/',
    GOOGLE_CLIENT_ID: '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '259853874853122',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'UA-45014247-30',
    domain: 'https://lka-devcsr-pwa.dominosindia.in',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  development4: {
    hostname: 'https://apis-dev1.dominoslk.com',
    GOOGLE_CLIENT_ID: '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '259853874853122',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'UA-45014247-30',
    domain: 'https://lka-devcsr-pwa.dominosindia.in',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  local: {
    hostname: 'https://lka-api.dominosindia.in',
    GOOGLE_CLIENT_ID: '749977844209-83edee24mpm9d8e32lrocgst4dpsg9l2.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '535449853591908',
    API_KEY: 'd2aeb489bb8df385',
    DESKTOP_API_KEY: 'd2aeb489bb8df385',
    GTM_TAG: 'UA-45014247-30',
    domain: 'http://localhost:4000',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  local_stage: {
    hostname: 'https://lka-api.dominosindia.in',
    GOOGLE_CLIENT_ID: '659528796466-olo38u4jbd6k1oj523k9f3ts1o9bldr6.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '259853874853122',
    API_KEY: 'fd2ed7880af4bdd2',
    DESKTOP_API_KEY: 'fd2ed7880af4bdd2',
    GTM_TAG: 'UA-45014247-30',
    domain: 'http://localhost:4000',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  stage: {
    hostname: 'https://apis-lka-s0.dominoslk.com', //'https://lka-s1.dominosindia.in',
    GOOGLE_CLIENT_ID: '757462283726-6f8vfs8fth5nnhigdf9eq5dflgrc0i1e.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '246788839330520',
    API_KEY: '1be746dc5827cf05',
    DESKTOP_API_KEY: '1be746dc5827cf05',
    GTM_TAG: 'GTM-5ZDCKWX',
    domain: 'https://lka-s0-csr-pwa.dominoslk.com', //'https://lka-s1-pwa.dominosindia.in',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_API_KEY_PWA: '17f43d783f8a20c512a97afc0ef4e2cf',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-SL-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639132',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    MOENGAGE_APP_ID: 'MTRYVV6RR168ATP5P36U1DUM'
  },
  image: {
    hostname: 'https://images.dominos.co.in/srilanka/'
  },
  s3Bucket: {
    production_migration: 'olo-lka-prod-api',
    production: 'olo-lka-prod-api',
    development1: 'lka-d1-olo-api',
    'lka-d1': 'lka-d1-olo-api',
    development2: 'stage-olo-api-bucket',
    development3: 'olo-lka-dev-api',
    development4: 'lka-d1-olo-api',
    local: 'olo-lka-dev-api',
    local_stage: 'olo-lka-dev-api',
    uat: 'lka-uat-olo-api',
    qa: 's1-olo-api-bucket',
    beta: 'olo-lka-prod-api',
    stage: 'lka-s0-olo-api'
  },
  cmsSiteBucket: {
    production: 'jflcms',
    development: 'jflcms',
    development1: 'jflcms',
    devcsr: 'jflcms',
    local: 'jflcms',
    dev0: 'jflcms',
    dev2: 'jflcms',
    dev4: 'jflcms',
    dev6: 'jflcms',
    stage: 'jflcms-s0',
    stage2: 'jflcms-s2',
    stage3: 'jflcms',
    stage4: 'jflcms-s4',
    stage6: 'jflcms-s6',
    stage7: 'jflcms-s7',
    stage8: 'jflcms-s8',
    stage9: 'jflcms-s9',
    stage1: 'jflcms-s1',
    local_stage: 'jflcms-s0',
    uat: 'jflcms',
  },
  map: {
    autoComplete: 'https://maps.googleapis.com/maps/api/place/autocomplete/json?components=country:in&region=en&key=AIzaSyDSo8kVS5Q-2YSGRxrK2LHTeSApG4SNnmU&userId=2172&input=',
  }
};

module.exports = sriLankaConfig;
